<div class="catalogs-container">
  <div class="disclaimer" *ngIf="disclaimerActive">
    <app-svg-icon svgIcon="info-cc"></app-svg-icon>
    <span style="flex: 1">{{ "agent.catalogue.skip" | translate }}</span>
    <app-svg-icon
      svgIcon="close-cc"
      (click)="disclaimerActive = false"
    ></app-svg-icon>
  </div>
  <app-agent-catalogs-list
    [initialSelectedCatalogs]="selectedCatalogs"
    (selectedCatalogsChange)="selectedCatalogsChange($event)"
    [noDisclaimer]="!disclaimerActive"
  ></app-agent-catalogs-list>
  <div class="actions">
    <button type="button" class="back" (click)="previous()">
      <img src="assets/icones/arrow-back-black.svg" alt="" />
      {{ "agent.actions.back" | translate }}
    </button>
    <div style="display: flex; flex-direction: row; gap: 20px">
      <button type="button" class="submit" (click)="next()">
        {{ "agent.actions.create_agent" | translate }}
        <img src="assets/icones/arrow-right.svg" alt="" />
      </button>
    </div>
  </div>
</div>
